var React = require('react');

function IconEyeIgnore (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M511.8 639.2c67.5 0 122.1-54.5 122.1-122.1 0-11.7-1.6-22.9-4.7-33.6L475.8 633.8c11.4 3.5 23.4 5.4 36 5.4z","key":0}),React.createElement("path",{"d":"M804.6 311.6L691.7 422.2c15 28.3 23.5 60.6 23.5 94.9 0 112.3-91.1 203.4-203.4 203.4-35.7 0-69.3-9.2-98.5-25.4l-90.4 88.6c58 24.8 121.8 38.6 188.9 38.6 203.4 0 377.2-126.5 447.6-305.2-32.3-81.8-86.2-152.7-154.8-205.5zM789 159.2l-91.7 89.9C640.2 225.2 577.5 212 511.8 212c-203.4 0-377.2 126.5-447.6 305.2 31.8 80.7 84.7 150.8 152 203.4l-65.3 64 41.9 42.8L830.9 202 789 159.2zM308.3 517.1c0-112.3 91.1-203.4 203.4-203.4 34.4 0 66.9 8.6 95.3 23.7l-63.2 61.9c-10.2-2.8-21-4.3-32.2-4.3-67.5 0-122.1 54.5-122.1 122.1 0 10.3 1.3 20.2 3.6 29.8l-63.2 61.9c-13.7-27.6-21.6-58.7-21.6-91.7z","key":1})]);
}

IconEyeIgnore.displayName = "IconEyeIgnore";

IconEyeIgnore.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconEyeIgnore;

IconEyeIgnore.default = IconEyeIgnore;
